import { render, staticRenderFns } from "./Ayar.vue?vue&type=template&id=76b801f9&scoped=true&"
import script from "./Ayar.vue?vue&type=script&lang=js&"
export * from "./Ayar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b801f9",
  null
  
)

export default component.exports